import { jsx as d } from "react/jsx-runtime";
import { createContext as h, useState as u, useEffect as l, useContext as T } from "react";
const f = {
  theme: "system",
  setTheme: () => null
}, r = h(f);
function x({
  children: t,
  defaultTheme: m = "system",
  storageKey: o = "vite-ui-theme",
  ...n
}) {
  const [s, i] = u(
    () => localStorage.getItem(o) || m
  );
  l(() => {
    const e = window.document.documentElement;
    if (e.classList.remove("light", "dark"), s === "system") {
      const a = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      e.classList.add(a);
      return;
    }
    e.classList.add(s);
  }, [s]);
  const c = {
    theme: s,
    setTheme: (e) => {
      localStorage.setItem(o, e), i(e);
    }
  };
  return /* @__PURE__ */ d(r.Provider, { ...n, value: c, children: t });
}
const g = () => {
  const t = T(r);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
};
export {
  x as ThemeProvider,
  g as useTheme
};
